module.exports = __webpack_public_path__ + "static/media/ico_download.2d8e817b.svg";